export default __webpack_public_path__ + "static/media/sorting_algorithm.873c6e6e.PNG";